/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpSubnet {
  /**
  * The id of the subnet
  */
  'id': number;
  /**
  * The URL of the network to which this subnetwork belongs
  */
  'vpcNetwork': string;
  /**
  * The name of the subnet
  */
  'name': string;
  /**
  * The project that owns this subnet (for shared subnets from other projects)
  */
  'project'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "vpcNetwork",
      "baseName": "vpcNetwork",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "project",
      "baseName": "project",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpSubnet.attributeTypeMap;
  }

  public constructor() {
  }
}

